import { Box, Stack } from '@mui/material'
import { interviewReservationFormUrl, interviewReservationSelectionCreateUrl } from '../../containers/common/constant/appUrl'
import { loginUrl } from '../../containers/common/constant/appUrl'
import { yesNo, interviewAcceptMethod } from '../../containers/common/constant/classification'
import { useAction } from '../../containers/facilityDetailAvailability/facilityDetailAvailabilityService'
import { translate, translateNode } from '../../i18n'
import { AnnotationLabel } from '../components/common/annotationLabel'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { BackButton } from '../components/common/buttons/backButton'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { GContainer, GItem } from '../components/common/grids'
import { AvailabilityCalendar } from '../components/common/inputs/availabilityCalendar'
import { DatePickerNoBind } from '../components/common/inputs/datePickerNoBind'
import { Form } from '../components/common/inputs/form'
import { Link } from '../components/common/link'
import DateSelection from '../components/common/reservationFlow/selection/dateSelection'
import FacilityLinkedName from '../components/common/reservationFlow/selection/facilityLinkedName'
import FacilityNoteCard from '../components/common/reservationFlow/selection/facilityNote'
import UseReasonSelection from '../components/common/reservationFlow/selection/useReasonSelection'
import DiagonosisSelection from '../components/facilityDetail/diagonosisSelection'



export const FacilityDetailAvailability = () => {
  const {
    state,
    formMethods,
    currentLocation,
    isLoggedIn,
    changeChildBirthday,
    changeDate,
    callTel,
    purposeOfUse,
    useReasonDetailIrregular,
    useReasonDetailEmg,
    useReasonDetailRefresh,
    onChangeUseReason,
    handleChangeFirst,
    handleChangeSecond
  } = useAction()

  if (!state) {
    return null
  }

  const isInterviewSlots = state.facility.interviewDailyAcceptFlag === yesNo.yes
                            && state.facility.interviewAcceptMethod === interviewAcceptMethod.interviewSlots
  const isPreinterviewAccept = state.facility.preinterviewAcceptFlag === yesNo.yes
  const isInterviewRequired = state.facility.interviewMethodFlag === yesNo.no

  return (
    <Stack spacing={2}> 
      <Form formMethods={formMethods}>
        <GContainer>
          <GItem md={3}></GItem>
          <GItem xs={12} md={6}>
            <Box>
              <GContainer rowSpacing={1}>
                <GItem xs={12}>
                  <FacilityLinkedName 
                    facilityId={state.facilityId}
                    facilityName={state.facility.facilityName}
                  />
                </GItem>
                <GItem xs={12}>
                  <Stack spacing={1}>
                    {/** 生年月日選択 */}
                    <Stack>
                      <div>
                        {translate('facilityDetailAvailability.label.ageClass')}
                      </div>
                      <DatePickerNoBind fullWidth value={state.childBirthday} onChange={changeChildBirthday} minDate={state.minBirthday} maxDate={state.maxBirthday}/>
                    </Stack>
                    {
                      state.commonFlag === yesNo.no
                      && Object.values(state.useReasonOptions).some((usage) => usage)
                      && (
                        <UseReasonSelection
                          useReason={state.useReason}
                          useReasonOptions={state.useReasonOptions}
                          facility={state.facility}
                          purposeOfUse={purposeOfUse?? ''}
                          useReasonDetailIrregular={useReasonDetailIrregular?? ''}
                          useReasonDetailEmg={useReasonDetailEmg?? ''}
                          useReasonDetailRefresh={useReasonDetailRefresh?? ''}
                          onChange={onChangeUseReason}
                          isDetailHidden
                          setValue={formMethods.setValue}
                        />
                      )
                    }
                    {
                      state.isolationFlag && (
                        <>
                          <DiagonosisSelection
                            diagonosisDecodeMst={state.diagonosisDecodeMst}
                            changeDropDownSelectedDiagonosis={handleChangeFirst}
                            state={state}
                            name={'first'}
                          />
                          <DiagonosisSelection
                            diagonosisDecodeMst={state.diagonosisDecodeMst}
                            changeDropDownSelectedDiagonosis={handleChangeSecond}
                            state={state}
                            name={'second'}
                          />
                        </>
                      )
                    }
                    <DateSelection activeDate={state.activeDate} onChange={changeDate} />
                  </Stack>
                </GItem>
                {
                  state.availabilities.length > 0 && (
                    <>
                      <GItem xs={12}>
                        <Stack spacing={2}>
                          <AnnotationLabel>{translate(state.usageGuideStr)}</AnnotationLabel>
                          <AvailabilityCalendar
                            name="usageDesiredDatetimes"
                            label={translate('facilityReservationSelection.label.availabilityCalendar')}
                            required
                            baseDate={state.activeDate}
                            receptionTimePattern={state.facility.receptionTimePattern}
                            availabilities={state.availabilities}
                            isMultiple={false}
                            onChangeBaseDate={changeDate}
                            control={formMethods.control}
                            isDisplayOnly
                            receptionTimeName={state.facility.receptionTimeName}
                          />
                        </Stack>
                      </GItem>
                      <GItem xs={12}>
                        {
                          state.note && (
                            <FacilityNoteCard>{state.note}</FacilityNoteCard>
                          )
                        }
                      </GItem>
                      <GItem xs={12}>
                        {
                          state.lotteryNote && (
                            <FacilityNoteCard>{state.lotteryNote}</FacilityNoteCard>
                          )
                        }
                      </GItem>
                    </>                
                  )
                }
              </GContainer>
            </Box>
            {
              state.availabilities.length > 0 && (
                <div>{translate('facilityReservationSelection.label.annotation')}</div>
              )
            }
            {!isLoggedIn && (
              <div>
                {translateNode(
                  'facilityDetailAvailability.text.loginAnnotation',
                  <Link
                    to={{
                      pathname: loginUrl.url(),
                      state: { from: currentLocation },
                    }}
                    replace
                  >
                    {translate('facilityDetailAvailability.text.loginHere')}
                  </Link>
                )}
              </div>
            )}
          </GItem>
          <GItem md={3}></GItem>
        </GContainer>
  
     
        <BottomButtonGroup>
          {
            isLoggedIn 
            && state.facility.reservationAcceptFlag === yesNo.no 
            && state.facility.notLoginCalendarDisplayFlag === yesNo.yes && (
              <ButtonOutlinedWarningL fullWidth onClick={() => callTel(state.facility.tel)}>
                {translate('facilityDetailAvailability.button.telReservation')}
              </ButtonOutlinedWarningL>
          )}
          {isPreinterviewAccept && !isInterviewSlots && isInterviewRequired && (
            <ButtonOutlinedWarningL fullWidth to={interviewReservationFormUrl.url(state.facilityId)}>
              {translate('facilityDetailAvailability.button.usageApplication')}
            </ButtonOutlinedWarningL>
          )}
          {isPreinterviewAccept && !isInterviewSlots && !isInterviewRequired && (
            <ButtonOutlinedWarningL fullWidth to={interviewReservationFormUrl.url(state.facilityId)}>
              {translate('facilityDetailAvailability.button.advanceApplication')}
            </ButtonOutlinedWarningL>
          )}
          {isPreinterviewAccept && isInterviewSlots && isInterviewRequired && (
            <ButtonOutlinedWarningL fullWidth to={interviewReservationSelectionCreateUrl.url(state.facilityId)}>
              {translate('facilityDetailAvailability.button.usageApplication')}
            </ButtonOutlinedWarningL>
          )}
          {isPreinterviewAccept && isInterviewSlots && !isInterviewRequired && (
            <ButtonOutlinedWarningL fullWidth to={interviewReservationSelectionCreateUrl.url(state.facilityId)}>
              {translate('facilityDetailAvailability.button.advanceApplication')}
            </ButtonOutlinedWarningL>
          )}
          <BackButton />
        </BottomButtonGroup>
      </Form>
    </Stack>
  )
}
